export default __webpack_public_path__ + "static/media/not-found.5815b24e.png";